// Resolves attorney-specific practice strings to canonical practice-area titles.

// --------------------------------------------------------------------------
// Canonical practice-area resolution
// --------------------------------------------------------------------------

// Exact-match lookup table (case-insensitive). Add a row here whenever a
// new attorney-specific string should resolve to a canonical PRACTICE_AREAS
// title.
const EXACT_MATCHES = {
  "civil litigation": "Civil Litigation & Appellate Advocacy",
  "general civil litigation": "Civil Litigation & Appellate Advocacy",
  "commercial litigation": "Civil Litigation & Appellate Advocacy",
  "appellate advocacy": "Civil Litigation & Appellate Advocacy",
  "fertility law": "Fertility Law",
  "employment law": "Employment Law",
  "employment disputes": "Employment Law",
  "constitutional law": "Constitutional Law",
  "family law": "Family Law",
  "real estate": "Real Estate",
  "real estate transactions": "Real Estate",
  "business law": "Business Law",
};

// Keyword-bucket rules — first match wins. Each entry maps an array of
// keyword tokens (lowercased substrings) to a canonical title.
const KEYWORD_BUCKETS = [
  { area: "Fertility Law", keywords: ["fertility", "surrogacy", "gestational", "assisted reproduction", "donor"] },
  { area: "Municipal & Government Law", keywords: ["municipal", "land use", "zoning"] },
  { area: "Real Estate", keywords: ["real estate", "property"] },
  { area: "Estate Planning & Probate", keywords: ["estate", "probate", "trust", "will", "succession planning", "wealth"] },
  { area: "Family Law", keywords: ["divorce", "paternity", "custody", "adoption", "guardianship", "qualified domestic"] },
  { area: "Business Law", keywords: ["business", "corporate", "intellectual property", "contract", "collections", "merger", "acquisition"] },
  { area: "Employment Law", keywords: ["employment"] },
  { area: "Constitutional Law", keywords: ["constitutional"] },
  { area: "Civil Litigation & Appellate Advocacy", keywords: ["appellate", "appeal", "litigation", "insurance", "personal injury", "product liability", "construction"] },
];

/**
 * Maps an attorney's specific practice-area string (as shown on their bio)
 * to the canonical PRACTICE_AREAS title used by the practice-area modal.
 * Returns null if the string doesn't correspond to any clickable practice area.
 */
export function mapToCanonicalPracticeArea(str) {
  if (!str) return null;
  const s = str.toLowerCase();
  if (EXACT_MATCHES[s]) return EXACT_MATCHES[s];
  for (const bucket of KEYWORD_BUCKETS) {
    if (bucket.keywords.some((k) => s.includes(k))) return bucket.area;
  }
  return null;
}
